import * as S from './Button.styled';
import { UnreadDot } from '../Dashboard.styled';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

type ButtonProps = Omit<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'onClick'
> & {
    children: React.ReactNode;
    border?: string;
    color?: string;
    background?: string;
    onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    style?: React.CSSProperties;
    isActive?: boolean;
    disabled?: boolean;
    isUnreadNotifications?: boolean;
};

const FooterButton = ({
    children,
    color,
    border,
    background,
    onClick,
    style = {},
    isActive,
    disabled,
    isUnreadNotifications,
    ...rest
}: ButtonProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    // t('******', { lng: language })

    return (
        <S.FooterButton
            style={{
                ...style,
            }}
            $isActive={isActive}
            border={border}
            color={color}
            background={background}
            onClick={onClick}
            disabled={disabled}
            isUnreadNotifications={isUnreadNotifications}
            {...rest}
        >
            {children}

            {Array.isArray(children) &&
                children.includes(t('notifications', { lng: language })) &&
                isUnreadNotifications && (
                    <UnreadDot style={{ marginLeft: '0.1rem', marginTop: '0.5rem' }} />
                )}
        </S.FooterButton>
    );
};

export default FooterButton;
